export default "__VITE_ASSET__C8gM$Tp$__"